module.exports = __webpack_public_path__ + "static/media/Technologyicon01.6e9d1348.png";